const ROOT_URL = 'https://lab.lectrum.io';
const MAIN_URL = `${ROOT_URL}/hw/todo/api`;
const TOKEN = 'Zvy9DNSTOGeryNqf';

export { ROOT_URL, MAIN_URL, TOKEN };
